var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "600px", persistent: "" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [
              _vm._v("Bulk Copy with Data Replacement"),
            ]),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-container",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-alert",
                            { attrs: { type: "info", dense: "", text: "" } },
                            [
                              _vm._v(
                                " Selected items will be copied and all occurrences of the search value will be replaced with the replace value. "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Search",
                              outlined: "",
                              dense: "",
                              hint: "Value to search for in the copied items",
                              "persistent-hint": "",
                              "error-messages": _vm.searchError,
                            },
                            model: {
                              value: _vm.searchValue,
                              callback: function ($$v) {
                                _vm.searchValue = $$v
                              },
                              expression: "searchValue",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Replace",
                              outlined: "",
                              dense: "",
                              hint: "Value to replace with",
                              "persistent-hint": "",
                              "error-messages": _vm.replaceError,
                            },
                            model: {
                              value: _vm.replaceValue,
                              callback: function ($$v) {
                                _vm.replaceValue = $$v
                              },
                              expression: "replaceValue",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.selectedCount > 0
                    ? _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "v-alert",
                                {
                                  attrs: {
                                    type: "warning",
                                    dense: "",
                                    text: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.selectedCount) +
                                      " item(s) selected for bulk copy "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "grey", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    disabled: !_vm.isValid,
                    loading: _vm.loading,
                  },
                  on: { click: _vm.apply },
                },
                [_vm._v("Apply")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }